/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsDesktopTower: {
  name: 'desktop-tower';
  data: string;
} = {
  name: 'desktop-tower',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7Zm0 2h10v2H7V5Zm0 4v2h10V9H7Zm0 10v-6h10v6H7Zm8-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
